import Base from "./Base";

class EventHandlers extends Base {

    static pauseHandler(body){
        return this.sendRequest('/event-handlers/pause-handler', 'POST', {}, body);
    }

    static resumeHandler(body){
        return this.sendRequest('/event-handlers/resume-handler', 'POST', {}, body);
    }

    static getHandlerDetails(body){
        return this.sendRequest('/event-handlers/get-handler-details', 'POST', {}, body);
    }
}

export default EventHandlers;